import styled from 'styled-components';

const Scale = styled.div<{ angle: number }>`
    color: #083461;
    margin: 10px;
    border: ${({ angle }) => '1px solid ' + (angle < 0 ? '#ed6f64' : '#a0d06e')};
    background-color: '#FFF';
    text-align: center;
    height: 20px;
    line-height: 18px;
    font-size: 14px;
    box-sizing: border-box;
    overflow: hidden;
`;

const Left = styled.div<{ angle: number }>`
    background-color: #ed6f64;
    font-weight: bold;
    text-align: right;
    padding-right: 3px;
    border-right: 1px solid #ed6f64;
    margin-right: 50%;
    margin-left: ${({ angle }) => ((angle + 90) * 50) / 90.0 + '%'};
`;

const Right = styled.div<{ angle: number }>`
    background-color: #a0d06e;
    font-weight: bold;
    text-align: left;
    padding-left: 3px;
    border-left: 1px solid #a0d06e;
    margin-left: 50%;
    margin-right: ${({ angle }) => ((90 - angle) * 50) / 90.0 + '%'};
`;

const Center = styled.div`
    border-left: 1px solid black;
    margin-left: 50%;
    text-align: left;
`;

export { Center, Left, Right, Scale };
